export function IngresoMenu() {
    return <>
    <div>
        <span  className="headicon "  >
            <span className="menuitem boxed"><a href="/analytics/ingresos_general">General</a></span>
            <span className="menuitem boxed"><a href="/analytics/ingresos_por_empresa">Por empresa</a></span>
            <span className="menuitem boxed"><a href="/analytics/ingresos_por_usuario">Por usuario</a></span>
        </span>
        </div>
    </>
}
export default IngresoMenu